
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class ListsService {

  currency = null;

  constructor(private http: HttpClient, private userService: UserService) { }


  getExchange(currency: string): Observable<any> {
    const url = 'https://api.2shapes.com/v1/exchange/' + currency;
    const headers = new HttpHeaders()
      .append('apikey', this.userService.user.apikey);

    return this.http.get(url, {
      headers
    }).pipe(
      map(res => {
        return res[currency];
      }));
  }

  getRoundMode() {
    return [
      { value: 'NONE', viewValue: 'None' },
      { value: 'INTEGER', viewValue: 'Integer' },
      { value: 'MULTIPLE10', viewValue: 'Multiple 10' },
      { value: 'ENDBY9', viewValue: 'End by 9' }
    ]
  }

  getCountryViewValue(country: string) {
    if (country !== null && country !== undefined) {
      return this.getCountries().find(d => d.value === country)?.viewValue;
    } else {
      return 'English';
    }
  }

  getLanguages() {
    return [
      {
        value: '1033', viewValue: 'English', symbolBefore: true
      },
      {
        value: '1034', viewValue: 'Spanish', symbolBefore: true
      },
      {
        value: '1036', viewValue: 'French', symbolBefore: true
      },
      {
        value: '1040', viewValue: 'Italian', symbolBefore: true
      },
      {
        value: '1027', viewValue: 'Catalan', symbolBefore: true
      },
      {
        value: '1031', viewValue: 'German', symbolBefore: true
      },
      {
        value: '1028', viewValue: 'Chinese Traditional', symbolBefore: true
      },
      {
        value: '2052', viewValue: 'Chinese Simplified', symbolBefore: true
      },
      {
        value: '1042', viewValue: 'Korean', symbolBefore: true
      },
      {
        value: '1041', viewValue: 'Japanese', symbolBefore: true
      },
      {
        value: '2070', viewValue: 'Portuguese', symbolBefore: true
      },
      // {
      //   value: '1045', viewValue: 'Polish', symbolBefore: true
      // },
      {
        value: '2073', viewValue: 'Russian', symbolBefore: true
      },
      // {
      //   value: '1066', viewValue: 'Vietnamese', symbolBefore: true
      // },
      // {
      //   value: '1037', viewValue: 'Hebrew', symbolBefore: true
      // },
      // {
      //   value: '1054', viewValue: 'Thai', symbolBefore: true
      // },
      // {
      //   value: '1025', viewValue: 'Arabic', symbolBefore: true
      // },
      // {
      //   value: '1048', viewValue: 'Rumanian', symbolBefore: true
      // },
      // {
      //   value: '1081', viewValue: 'Hindi', symbolBefore: true
      // },
      // {
      //   value: '1057', viewValue: 'Indonesian', symbolBefore: true
      // },
      // {
      //   value: '2117', viewValue: 'Bengalí', symbolBefore: true
      // },
      // {
      //   value: '1056', viewValue: 'Urdu', symbolBefore: true
      // },
      // {
      //   value: '1067', viewValue: 'Armenian', symbolBefore: true
      // },
      // {
      //   value: '1055', viewValue: 'Turkish', symbolBefore: true
      // },
      // {
      //   value: '1043', viewValue: 'Dutch', symbolBefore: true
      // },
      {
        value: '1029', viewValue: 'Czech', symbolBefore: true
      },
      // {
      //   value: '1026', viewValue: 'Bulgarian', symbolBefore: true
      // },
      // {
      //   value: '1030', viewValue: 'Danish', symbolBefore: true
      // },
      // {
      //   value: '1065', viewValue: 'Farsi', symbolBefore: true
      // },
      // {
      //   value: '1050', viewValue: 'Croatian', symbolBefore: true
      // },
      // {
      //   value: '1107', viewValue: 'Khmer', symbolBefore: true
      // },
      // {
      //   value: '1058', viewValue: 'Ukrainian', symbolBefore: true
      // },
      // {
      //   value: '1035', viewValue: 'Finnish', symbolBefore: true
      // },
      // {
      //   value: '1038', viewValue: 'Hungarian', symbolBefore: true
      // },
      // {
      //   value: '1086', viewValue: 'Malay', symbolBefore: true
      // },
      // {
      //   value: '1044', viewValue: 'Norwegian', symbolBefore: true
      // },
      // {
      //   value: '1053', viewValue: 'Swedish', symbolBefore: true
      // },
      // {
      //   value: '1032', viewValue: 'Greek', symbolBefore: true
      // },
    ];
  }

  getLanguagesToTranslate() {
    return [
      {
        value: '1033', viewValue: 'en', symbolBefore: true
      },
      {
        value: '1034', viewValue: 'es', symbolBefore: true
      },
      {
        value: '1036', viewValue: 'fr', symbolBefore: true
      },
      {
        value: '1040', viewValue: 'it', symbolBefore: true
      },
      {
        value: '1027', viewValue: 'ca', symbolBefore: true
      },
      {
        value: '1031', viewValue: 'de', symbolBefore: true
      },
      {
        value: '1028', viewValue: 'zhcht', symbolBefore: true
      },
      {
        value: '2052', viewValue: 'zhchs', symbolBefore: true
      },
      {
        value: '1042', viewValue: 'ko', symbolBefore: true
      },
      {
        value: '1041', viewValue: 'ja', symbolBefore: true
      },
      {
        value: '2070', viewValue: 'pt', symbolBefore: true
      },
      {
        value: '2073', viewValue: 'ru', symbolBefore: true
      },
      {
        value: '1066', viewValue: 'vi', symbolBefore: true
      },
      {
        value: '1037', viewValue: 'he', symbolBefore: true
      },
      {
        value: '1054', viewValue: 'th', symbolBefore: true
      },
      {
        value: '1025', viewValue: 'ar', symbolBefore: true
      },
      {
        value: '1048', viewValue: 'ro', symbolBefore: true
      },
      {
        value: '1067', viewValue: 'hy', symbolBefore: true
      },
      {
        value: '1055', viewValue: 'tr', symbolBefore: true
      },
      {
        value: '1043', viewValue: 'nl', symbolBefore: true
      },
      {
        value: '1029', viewValue: 'cs', symbolBefore: true
      },
      {
        value: '1026', viewValue: 'bg', symbolBefore: true
      },
      {
        value: '1030', viewValue: 'da', symbolBefore: true
      },
      {
        value: '1065', viewValue: 'fa', symbolBefore: true
      },
      {
        value: '1050', viewValue: 'hr', symbolBefore: true
      },
      {
        value: '1107', viewValue: 'km', symbolBefore: true
      },
      {
        value: '1058', viewValue: 'uk', symbolBefore: true
      },
      {
        value: '1081', viewValue: 'hi', symbolBefore: true
      },
      {
        value: '1057', viewValue: 'id', symbolBefore: true
      },
      {
        value: '2117', viewValue: 'bn', symbolBefore: true
      },
      {
        value: '1056', viewValue: 'ur', symbolBefore: true
      },
      {
        value: '1035', viewValue: 'fi', symbolBefore: true
      },
      {
        value: '1038', viewValue: 'hu', symbolBefore: true
      },
      {
        value: '1086', viewValue: 'ms', symbolBefore: true
      },
      {
        value: '1044', viewValue: 'nb', symbolBefore: true
      },
      {
        value: '1053', viewValue: 'sv', symbolBefore: true
      },
      {
        value: '1032', viewValue: 'gr', symbolBefore: true
      },
      {
        value: '1045', viewValue: 'pl', symbolBefore: true
      },
    ];
  }


  getLanguageCode(lang: string) {

    switch (lang) {
      case 'en':
        return 1033;
      case 'ca':
        return 1027;
      case 'es':
        return 1034;
      case 'fr':
        return 1036;
      case 'it':
        return 1040;
      case 'ja':
        return 1041;
      case 'ko':
        return 1042;
      case 'zhcht':
        return 1028;
      case 'zhchs':
        return 2052;
      case 'pt':
        return 2070;
      case 'ru':
        return 2073;
      case 'he':
        return 1037;
      case 'vi':
        return 1066;
      case 'th':
        return 1054;
      case 'ar':
        return 1025;
      case 'de':
        return 1031;
      case 'ro':
        return 1048;
      case 'hy':
        return 1067;
      case 'tr':
        return 1055;
      case 'nl':
        return 1043;
      case 'cs':
        return 1029;
      case 'bg':
        return 1026;
      case 'da':
        return 1030;
      case 'fa':
        return 1065;
      case 'hr':
        return 1050;
      case 'km':
        return 1107;
      case 'uk':
        return 1058;
      case 'hi':
        return 1081;
      case 'id':
        return 1057;
      case 'bn':
        return 2117;
      case 'ur':
        return 1056;
      case 'fi':
        return 10;
      case 'hu':
        return 1038;
      case 'ms':
        return 1086;
      case 'nb':
        return 1044;
      case 'sv':
        return 1053;
      case 'gr':
        return 1032;
      case 'pl':
        return 1045;
      default:
        return 1033;
    }
  }



  getMaterials() {
    return [
      {
        value: 'GOLD_YELLOW_24',
        viewValue: 'PURE GOLD',
      },
      {
        value: 'GOLD_YELLOW_22',
        viewValue: '22K YELLOW GOLD',
      },
      {
        value: 'GOLD_YELLOW_18',
        viewValue: '18K YELLOW GOLD',
      },
      {
        value: 'GOLD_YELLOW_14',
        viewValue: '14K YELLOW GOLD',
      },
      {
        value: 'GOLD_YELLOW_10',
        viewValue: '10K YELLOW GOLD',
      },
      {
        value: 'GOLD_YELLOW_9',
        viewValue: '9k YELLOW GOLD',
      },
      {
        value: 'GOLD_WHITE_18',
        viewValue: '18K WHITE GOLD',
      },
      {
        value: 'GOLD_WHITE_14',
        viewValue: '14K WHITE GOLD',
      },
      {
        value: 'GOLD_WHITE_10',
        viewValue: '10K WHITE GOLD',
      },
      {
        value: 'GOLD_WHITE_9',
        viewValue: '9K WHITE GOLD',
      },
      {
        value: 'GOLD_ROSE_18',
        viewValue: '18K ROSE GOLD',
      },
      {
        value: 'GOLD_ROSE_14',
        viewValue: '14K ROSE GOLD',
      },
      {
        value: 'GOLD_ROSE_10',
        viewValue: '10K ROSE GOLD',
      },
      {
        value: 'GOLD_ROSE_9',
        viewValue: '9K ROSE GOLD',
      },
    ];
  }

  getMaterialName(material: string): string {
    switch (material) {
      case 'GOLD_YELLOW_24':
        return 'PURE GOLD';
      case 'GOLD_YELLOW_22':
        return '22K YELLOW GOLD';
      case 'GOLD_YELLOW_18':
        return '18K YELLOW GOLD';
      case 'GOLD_YELLOW_14':
        return '14K YELLOW GOLD';
      case 'GOLD_YELLOW_10':
        return '10K YELLOW GOLD';
      case 'GOLD_YELLOW_9':
        return '9k YELLOW GOLD';
      case 'GOLD_WHITE_18':
        return '18K WHITE GOLD';
      case 'GOLD_WHITE_14':
        return '14K WHITE GOLD';
      case 'GOLD_WHITE_10':
        return '10K WHITE GOLD';
      case 'GOLD_WHITE_9':
        return '9K WHITE GOLD';
      case 'GOLD_ROSE_18':
        return '18K ROSE GOLD';
      case 'GOLD_ROSE_14':
        return '14K ROSE GOLD';
      case 'GOLD_ROSE_10':
        return '10K ROSE GOLD';
      case 'GOLD_ROSE_9':
        return '9K ROSE GOLD';
      default:
        return null;
    }
  }

  getCurrencies() {
    return [
      {
        value: 'AED',
        viewValue: 'United Arab Emirates Dirham',
        symbol: 'د.إ',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'AFN',
        viewValue: 'Afghan Afghani',
        symbol: '؋',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'ALL',
        viewValue: 'Albanian Lek',
        symbol: 'L',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'AMD',
        viewValue: 'Armenian Dram',
        symbol: 'AMD',
        decimals: 2,
        symbolBefore: true

      },
      {
        value: 'ANG',
        viewValue: 'Netherlands Antillean Guilder',
        symbol: 'NAƒ',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'AOA',
        viewValue: 'Angolan Kwanza',
        symbol: 'Kz',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'ARS',
        viewValue: 'Argentine Peso',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'AUD',
        viewValue: 'Australian Dollar',
        symbol: '$',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'AWG',
        viewValue: 'Aruban Florin',
        symbol: 'ƒ',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'AZN',
        viewValue: 'Azerbaijani Manat',
        symbol: 'AZN',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'BAM',
        viewValue: 'Bosnia-Herzegovina Convertible Mark',
        symbol: 'KM',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'BBD',
        viewValue: 'Barbadian Dollar',
        symbol: 'Bds$',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'BDT',
        viewValue: 'Bangladeshi Taka',
        symbol: '৳',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'BGN',
        viewValue: 'Bulgarian Lev',
        symbol: 'BGN',
        decimals: 2,
        symbolBefore: true
      },
      {
        value: 'BHD',
        viewValue: 'Bahraini Dinar',
        symbol: '.د.ب',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'BIF',
        viewValue: 'Burundian Franc',
        symbol: 'FBu',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'BMD',
        viewValue: 'Bermudan Dollar',
        symbol: 'BD$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BND',
        viewValue: 'Brunei Dollar',
        symbol: 'B$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BOB',
        viewValue: 'Bolivian Boliviano',
        symbol: 'Bs.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BRL',
        viewValue: 'Brazilian Real',
        symbol: 'R$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BSD',
        viewValue: 'Bahamian Dollar',
        symbol: 'B$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BTC',
        viewValue: 'Bitcoin',
        symbol: '₿',
        decimals: 8
        , symbolBefore: true
      },
      {
        value: 'BTN',
        viewValue: 'Bhutanese Ngultrum',
        symbol: 'Nu.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BWP',
        viewValue: 'Botswanan Pula',
        symbol: 'P',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'BYN',
        viewValue: 'Belarusian Ruble',
        symbol: 'Br',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'BYR',
        viewValue: 'Belarusian Ruble',
        symbol: 'Br',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'BZD',
        viewValue: 'Belize Dollar',
        symbol: 'BZ$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CAD',
        viewValue: 'Canadian Dollar',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CDF',
        viewValue: 'Congolese Franc',
        symbol: 'F',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CHF',
        viewValue: 'Swiss Franc',
        symbol: 'Fr.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CLF',
        viewValue: 'Chilean Unit of Account (UF)',
        symbol: 'UF',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'CLP',
        viewValue: 'Chilean Peso',
        symbol: '$',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'CNY',
        viewValue: 'Chinese Yuan',
        symbol: '¥',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'COP',
        viewValue: 'Colombian Peso',
        symbol: 'Col$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CRC',
        viewValue: 'Costa Rican Colón',
        symbol: '₡',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CUC',
        viewValue: 'Cuban Convertible Peso',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CUP',
        viewValue: 'Cuban Peso',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'CVE',
        viewValue: 'Cape Verdean Escudo',
        symbol: 'Esc',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'CSK',
        viewValue: 'Czech Republic Koruna',
        symbol: 'Kč',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'DJF',
        viewValue: 'Djiboutian Franc',
        symbol: 'Fdj',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'DKK',
        viewValue: 'Danish Krone',
        symbol: 'Kr',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'DOP',
        viewValue: 'Dominican Peso',
        symbol: 'RD$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'DZD',
        viewValue: 'Algerian Dinar',
        symbol: 'دج',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'EGP',
        viewValue: 'Egyptian Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ERN',
        viewValue: 'Eritrean Nakfa',
        symbol: 'ናቕፋ',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ETB',
        viewValue: 'Ethiopian Birr',
        symbol: 'Br',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'EUR',
        viewValue: 'Euro',
        symbol: '€',
        decimals: 2
        , symbolBefore: false
      },
      {
        value: 'FJD',
        viewValue: 'Fijian Dollar',
        symbol: 'FJ$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'FKP',
        viewValue: 'Falkland Islands Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GBP',
        viewValue: 'British Pound Sterling',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GEL',
        viewValue: 'Georgian Lari',
        symbol: 'GEL',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GGP',
        viewValue: 'Guernsey Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GHS',
        viewValue: 'Ghanaian Cedi',
        symbol: '₵',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GIP',
        viewValue: 'Gibraltar Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GMD',
        viewValue: 'Gambian Dalasi',
        symbol: 'D',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GNF',
        viewValue: 'Guinean Franc',
        symbol: 'FG',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'GTQ',
        viewValue: 'Guatemalan Quetzal',
        symbol: 'Q',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'GYD',
        viewValue: 'Guyanaese Dollar',
        symbol: 'GY$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'HKD',
        viewValue: 'Hong Kong Dollar',
        symbol: 'HK$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'HNL',
        viewValue: 'Honduran Lempira',
        symbol: 'L',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'HRK',
        viewValue: 'Croatian Kuna',
        symbol: 'kn',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'HTG',
        viewValue: 'Haitian Gourde',
        symbol: 'G',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'HUF',
        viewValue: 'Hungarian Forint',
        symbol: 'Ft',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'IDR',
        viewValue: 'Indonesian Rupiah',
        symbol: 'Rp',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'ILS',
        viewValue: 'Israeli New Sheqel',
        symbol: '₪',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'IMP',
        viewValue: 'Manx pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'INR',
        viewValue: 'Indian Rupee',
        symbol: '₹',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'IQD',
        viewValue: 'Iraqi Dinar',
        symbol: 'د.ع',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'IRR',
        viewValue: 'Iranian Rial',
        symbol: 'IRR',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'ISK',
        viewValue: 'Icelandic Króna',
        symbol: 'kr',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'JEP',
        viewValue: 'Jersey Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'JMD',
        viewValue: 'Jamaican Dollar',
        symbol: 'J$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'JOD',
        viewValue: 'Jordanian Dinar',
        symbol: 'JOD',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'JPY',
        viewValue: 'Japanese Yen',
        symbol: '¥',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'KES',
        viewValue: 'Kenyan Shilling',
        symbol: 'KSh',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'KGS',
        viewValue: 'Kyrgystani Som',
        symbol: 'Лв',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'KHR',
        viewValue: 'Cambodian Riel',
        symbol: '៛',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'KMF',
        viewValue: 'Comorian Franc',
        symbol: 'KMF',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'KPW',
        viewValue: 'North Korean Won',
        symbol: 'W',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'KRW',
        viewValue: 'South Korean Won',
        symbol: 'W',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'KWD',
        viewValue: 'Kuwaiti Dinar',
        symbol: 'KWD',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'KYD',
        viewValue: 'Cayman Islands Dollar',
        symbol: 'KY$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'KZT',
        viewValue: 'Kazakhstani Tenge',
        symbol: 'T',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LAK',
        viewValue: 'Laotian Kip',
        symbol: 'KN',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'LBP',
        viewValue: 'Lebanese Pound',
        symbol: '£',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'LKR',
        viewValue: 'Sri Lankan Rupee',
        symbol: 'Rs',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LRD',
        viewValue: 'Liberian Dollar',
        symbol: 'L$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LSL',
        viewValue: 'Lesotho Loti',
        symbol: 'M',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LTL',
        viewValue: 'Lithuanian litas',
        symbol: 'Lt',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LVL',
        viewValue: 'Latvian lats',
        symbol: 'Ls',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'LYD',
        viewValue: 'Libyan Dinar',
        symbol: 'LD',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'MAD',
        viewValue: 'Moroccan Dirham',
        symbol: 'MAD',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MDL',
        viewValue: 'Moldovan Leu',
        symbol: 'MDL',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MGA',
        viewValue: 'Malagasy Ariary',
        symbol: 'FMG',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MKD',
        viewValue: 'Macedonian Denar',
        symbol: 'MKD',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MMK',
        viewValue: 'Myanma Kyat',
        symbol: 'K',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'MNT',
        viewValue: 'Mongolian Tugrik',
        symbol: '₮',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MOP',
        viewValue: 'Macanese Pataca',
        symbol: 'P',
        decimals: 1
        , symbolBefore: true
      },
      {
        value: 'MRO',
        viewValue: 'Mauritanian Ouguiya (pre-2018)',
        symbol: 'UM',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MUR',
        viewValue: 'Mauritian Rupee',
        symbol: 'Rs',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MVR',
        viewValue: 'Maldivian Rufiyaa',
        symbol: 'Rf',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MWK',
        viewValue: 'Malawian Kwacha',
        symbol: 'MK',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MXN',
        viewValue: 'Mexican Peso',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MYR',
        viewValue: 'Malaysian Ringgit',
        symbol: 'RM',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'MZN',
        viewValue: 'Mozambican Metical',
        symbol: 'MTn',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NAD',
        viewValue: 'Namibian Dollar',
        symbol: 'N$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NGN',
        viewValue: 'Nigerian Naira',
        symbol: '₦',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NIO',
        viewValue: 'Nicaraguan Córdoba',
        symbol: 'C$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NOK',
        viewValue: 'Norwegian Krone',
        symbol: 'kr',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NPR',
        viewValue: 'Nepalese Rupee',
        symbol: 'NRs',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'NZD',
        viewValue: 'New Zealand Dollar',
        symbol: 'NZ$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'OMR',
        viewValue: 'Omani Rial',
        symbol: 'OMR',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'PAB',
        viewValue: 'Panamanian Balboa',
        symbol: 'B/.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PEN',
        viewValue: 'Peruvian Nuevo Sol',
        symbol: 'S/',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PGK',
        viewValue: 'Papua New Guinean Kina',
        symbol: 'K',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PHP',
        viewValue: 'Philippine Peso',
        symbol: '₱',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PKR',
        viewValue: 'Pakistani Rupee',
        symbol: 'Rs.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PLN',
        viewValue: 'Polish Zloty',
        symbol: 'zł',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'PYG',
        viewValue: 'Paraguayan Guarani',
        symbol: '₲',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'QAR',
        viewValue: 'Qatari Rial',
        symbol: 'QR',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'RON',
        viewValue: 'Romanian Leu',
        symbol: 'L',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'RSD',
        viewValue: 'Serbian Dinar',
        symbol: 'din.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'RUB',
        viewValue: 'Russian Rubl',
        symbol: 'R',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'RWF',
        viewValue: 'Rwandan Franc',
        symbol: 'R₣',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'SAR',
        viewValue: 'Saudi Riyal',
        symbol: 'SR',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SBD',
        viewValue: 'Solomon Islands Dollar',
        symbol: 'SI$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SCR',
        viewValue: 'Seychellois Rupee',
        symbol: 'SR',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SDG',
        viewValue: 'Sudanese Pound',
        symbol: 'SDG',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SEK',
        viewValue: 'Swedish Krona',
        symbol: 'kr',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SGD',
        viewValue: 'Singapore Dollar',
        symbol: 'S$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SHP',
        viewValue: 'Saint Helena Pound',
        symbol: '£',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SLL',
        viewValue: 'Sierra Leonean Leone',
        symbol: 'Le',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'SOS',
        viewValue: 'Somali Shilling',
        symbol: 'Sh.',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SRD',
        viewValue: 'Surinamese Dollar',
        symbol: '$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'STD',
        viewValue: 'São Tomé and Príncipe Dobra',
        symbol: 'Db',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'SVC',
        viewValue: 'Salvadoran Colón',
        symbol: '₡',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SYP',
        viewValue: 'Syrian Pound',
        symbol: 'LS',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'SZL',
        viewValue: 'Swazi Lilangeni',
        symbol: 'E',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'THB',
        viewValue: 'Thai Baht',
        symbol: '฿',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TJS',
        viewValue: 'Tajikistani Somoni',
        symbol: 'TJS',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TMT',
        viewValue: 'Turkmenistani Manat',
        symbol: 'm',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TND',
        viewValue: 'Tunisian Dinar',
        symbol: 'DT',
        decimals: 3
        , symbolBefore: true
      },
      {
        value: 'TOP',
        viewValue: 'Tongan Paanga',
        symbol: 'T$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TRY',
        viewValue: 'Turkish Lira',
        symbol: 'TRY',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TTD',
        viewValue: 'Trinidad and Tobago Dollar',
        symbol: 'TT$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TWD',
        viewValue: 'New Taiwan Dollar',
        symbol: 'NT$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'TZS',
        viewValue: 'Tanzanian Shilling',
        symbol: 'TZS',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'UAH',
        viewValue: 'Ukrainian Hryvnia',
        symbol: 'UAH',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'UGX',
        viewValue: 'Ugandan Shilling',
        symbol: 'USh',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'USD',
        viewValue: 'United States Dollar',
        symbol: 'US$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'UYU',
        viewValue: 'Uruguayan Peso',
        symbol: '$U',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'UZS',
        viewValue: 'Uzbekistan Som',
        symbol: 'UZS',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'VEF',
        viewValue: 'Venezuelan Bolívar Fuerte (Old)',
        symbol: 'Bs',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'VND',
        viewValue: 'Vietnamese Dong',
        symbol: '₫',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'VUV',
        viewValue: 'Vanuatu Vatu',
        symbol: 'VT',
        decimals: 0
        , symbolBefore: true
      },
      {
        value: 'WST',
        viewValue: 'Samoan Tala',
        symbol: 'WS$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'XAF',
        viewValue: 'CFA Franc BEAC',
        symbol: 'CFA',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'XCD',
        viewValue: 'East Caribbean Dollar',
        symbol: 'EC$',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'XOF',
        viewValue: 'CFA Franc BCEAO',
        symbol: 'CFA',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'XPF',
        viewValue: 'CFP Franc',
        symbol: '₣',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'YER',
        viewValue: 'Yemeni Rial',
        symbol: '﷼',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ZAR',
        viewValue: 'South African Rand',
        symbol: 'R',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ZMK',
        viewValue: 'Zambian Kwacha',
        symbol: 'ZK',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ZMW',
        viewValue: 'Zambian Kwacha',
        symbol: 'ZK',
        decimals: 2
        , symbolBefore: true
      },
      {
        value: 'ZWL',
        viewValue: 'Zimbabwean Dollar',
        symbol: 'Z$',
        decimals: 2
        , symbolBefore: true
      }
    ];
  }


  hasNoPrice(price: any): boolean {

    return price === 0 || price === undefined || price === null;

  }
  getPrice(price: any, currencyType: string, noPriceMessage: string = '--') {


    if (price === undefined || price === null) {
      price = 0;
    }

    if (price == 0) {
      return noPriceMessage;
    }
    let currency = null;

    if (this.currency && this.currency?.value === currencyType) {
      currency = this.currency;
    } else {
      currency = this.getCurrencies().find(f => f.value === currencyType);
    }

    if (!currency) {
      return '--';
    }

    // HACK USD
    if (currency.value === 'USD') currency.decimals = 2;

    price = (price.toFixed(currency.decimals) as number);

    price = Intl.NumberFormat('en-US').format(price);


    this.currency = currency;
    if (currency.symbolBefore === true) {
      return currency.symbol + ' ' + price;

    } else {
      return price + ' ' + currency.symbol;

    }

  }

  getCurrencySymbol(currency: string): string | undefined {
    if (this.getCurrencies().find(f => f.value === currency)) {
      if (this.getCurrencies().find(f => f.value === currency)?.symbol) {
        return this.getCurrencies().find(f => f.value === currency)?.symbol;
      }
    }
    return '€';

  }

  getCurrencyDecimal(currency: string): number {
    if (this.getCurrencies().filter(f => f.value === currency)[0]) {
      return this.getCurrencies().filter(f => f.value === currency)[0].decimals;
    }
    return 0;
  }


  getCurrencyFull(currency: string) {
    return this.getCurrencies().find(f => f.value == currency);
  }

  getFingerRegions() {
    return [

      {
        value: 'BRITISH',
        viewValue: 'British'
      },
      {
        value: 'AUSTRALIAN',
        viewValue: 'Australian'
      },
      {
        value: 'USA',
        viewValue: 'United States of America'

      },
      {
        value: 'FRANCE',
        viewValue: 'France'
      },
      {
        value: 'RUSSIA',
        viewValue: 'Russia'
      },
      {
        value: 'GERMANY',
        viewValue: 'Germany',
      },
      {
        value: 'JAPAN',
        viewValue: 'Japan',
      },
      {
        value: 'SWISSLAND',
        viewValue: 'swissland'
      },
      {
        value: 'ITALY',
        viewValue: 'Italy'
      },
      {
        value: 'EUROPE',
        viewValue: 'Europe'

      },
      {
        value: 'CANADA',
        viewValue: 'Canada',

      },
      {
        value: 'INDIA',
        viewValue: 'India',

      },
      {
        value: 'CHINA',
        viewValue: 'China',
      },
      {
        value: 'BRAZIL',
        viewValue: 'South America',

      },
      {
        value: 'TURKEY',
        viewValue: 'Turkey',

      },
      {
        value: 'ISRAEL',
        viewValue: 'Israel',
      }

    ];
  }

  getLicenses() {
    return [
      {
        value: 'GNUAGPLV3', viewValue: 'GNU AGPLv3', symbolBefore: true
      },
      {
        value: 'GNUGPLV3', viewValue: 'GNU GPLv3', symbolBefore: true
      },
      {
        value: 'GNULGPLV3', viewValue: 'GNU LGPLv3', symbolBefore: true
      },
      {
        value: 'MOZILLAPUBLICLICENSE2', viewValue: 'Mozilla Public License 2.0', symbolBefore: true
      },
      {
        value: 'APACHELICENSE2', viewValue: 'Apache License 2.0', symbolBefore: true
      },
      {
        value: 'MIT', viewValue: 'MIT License', symbolBefore: true
      },
      { value: 'UNLICENSE', viewValue: 'The Unlicense' }
    ];
  }
  getCountries() {
    return [
      {
        value: 'AM', viewValue: 'Armenia', symbolBefore: true
      },
      {
        value: 'AO', viewValue: 'Angola', symbolBefore: true
      },
      {
        value: 'AQ', viewValue: 'Antarctica', symbolBefore: true
      },
      {
        value: 'AD', viewValue: 'Andorra', symbolBefore: true
      },
      {
        value: 'AR', viewValue: 'Argentina', symbolBefore: true
      },
      {
        value: 'AS', viewValue: 'American Samoa', symbolBefore: true
      },
      {
        value: 'AT', viewValue: 'Austria', symbolBefore: true
      },
      {
        value: 'AU', viewValue: 'Australia', symbolBefore: true
      },
      {
        value: 'AW', viewValue: 'Aruba', symbolBefore: true
      },
      {
        value: 'AX', viewValue: 'Åland Islands', symbolBefore: true
      },
      {
        value: 'AZ', viewValue: 'Azerbaijan', symbolBefore: true
      },
      {
        value: 'BA', viewValue: 'Bosnia and Herzegovina', symbolBefore: true
      },
      {
        value: 'BB', viewValue: 'Barbados', symbolBefore: true
      },
      {
        value: 'BD', viewValue: 'Bangladesh', symbolBefore: true
      },
      {
        value: 'BE', viewValue: 'Belgium', symbolBefore: true
      },
      {
        value: 'BF', viewValue: 'Burkina Faso', symbolBefore: true
      },
      {
        value: 'BG', viewValue: 'Bulgaria', symbolBefore: true
      },
      {
        value: 'BH', viewValue: 'Bahrain', symbolBefore: true
      },
      {
        value: 'BI', viewValue: 'Burundi', symbolBefore: true
      },
      {
        value: 'BJ', viewValue: 'Benin', symbolBefore: true
      },
      {
        value: 'BL', viewValue: 'Saint Barthélemy', symbolBefore: true
      },
      {
        value: 'BM', viewValue: 'Bermuda', symbolBefore: true
      },
      {
        value: 'BN', viewValue: 'Brunei Darussalam', symbolBefore: true
      },
      {
        value: 'BO', viewValue: 'Bolivia', symbolBefore: true
      },
      {
        value: 'BQ', viewValue: 'Bonaire', symbolBefore: true
      },
      {
        value: 'BR', viewValue: 'Brazil', symbolBefore: true
      },
      {
        value: 'BS', viewValue: 'Bahamas', symbolBefore: true
      },
      {
        value: 'BT', viewValue: 'Bhutan', symbolBefore: true
      },
      {
        value: 'BV', viewValue: 'Bouvet Island', symbolBefore: true
      },
      {
        value: 'BW', viewValue: 'Botswana', symbolBefore: true
      },
      {
        value: 'BY', viewValue: 'Belarus', symbolBefore: true
      },
      {
        value: 'BZ', viewValue: 'Belize', symbolBefore: true
      },
      {
        value: 'CA', viewValue: 'Canada', symbolBefore: true
      },
      {
        value: 'CC', viewValue: 'Cocos Islands', symbolBefore: true
      },
      {
        value: 'CD', viewValue: 'Democratic Republic of the Congo', symbolBefore: true
      },
      {
        value: 'CF', viewValue: 'Central African Republic', symbolBefore: true
      },
      {
        value: 'CG', viewValue: 'Congo', symbolBefore: true
      },
      {
        value: 'CH', viewValue: 'Switzerland', symbolBefore: true
      },
      {
        value: 'CI', viewValue: 'Ivory Coast', symbolBefore: true
      },
      {
        value: 'CK', viewValue: 'Cook Islands', symbolBefore: true
      },
      {
        value: 'CL', viewValue: 'Chile', symbolBefore: true
      },
      {
        value: 'CM', viewValue: 'Cameroon', symbolBefore: true
      },
      {
        value: 'CN', viewValue: 'China', symbolBefore: true
      },
      {
        value: 'CO', viewValue: 'Colombia', symbolBefore: true
      },
      {
        value: 'CR', viewValue: 'Costa Rica', symbolBefore: true
      },
      {
        value: 'CU', viewValue: 'Cuba', symbolBefore: true
      },
      {
        value: 'CV', viewValue: 'Cabo Verde', symbolBefore: true
      },
      {
        value: 'CW', viewValue: 'Curaçao', symbolBefore: true
      },
      {
        value: 'CX', viewValue: 'Christmas Island', symbolBefore: true
      },
      {
        value: 'CY', viewValue: 'Cyprus', symbolBefore: true
      },
      {
        value: 'CZ', viewValue: 'Czechia', symbolBefore: true
      },
      {
        value: 'DE', viewValue: 'Germany', symbolBefore: true
      },
      {
        value: 'DJ', viewValue: 'Djibouti', symbolBefore: true
      },
      {
        value: 'DK', viewValue: 'Denmark', symbolBefore: true
      },
      {
        value: 'DM', viewValue: 'Dominica', symbolBefore: true
      },
      {
        value: 'DO', viewValue: 'Dominican Republic', symbolBefore: true
      },
      {
        value: 'DZ', viewValue: 'Algeria', symbolBefore: true
      },
      {
        value: 'EC', viewValue: 'Ecuador', symbolBefore: true
      },
      {
        value: 'EE', viewValue: 'Estonia', symbolBefore: true
      },
      {
        value: 'EG', viewValue: 'Egypt', symbolBefore: true
      },
      {
        value: 'EH', viewValue: 'Western Sahara', symbolBefore: true
      },
      {
        value: 'ER', viewValue: 'Eritrea', symbolBefore: true
      },
      {
        value: 'ES', viewValue: 'Spain', symbolBefore: true
      },
      {
        value: 'ET', viewValue: 'Ethiopia', symbolBefore: true
      },
      {
        value: 'FI', viewValue: 'Finland', symbolBefore: true
      },
      {
        value: 'FJ', viewValue: 'Fiji', symbolBefore: true
      },
      {
        value: 'FK', viewValue: 'Falkland Islands (Malvinas)', symbolBefore: true
      },
      {
        value: 'FM', viewValue: 'Micronesia, Federated States of', symbolBefore: true
      },
      {
        value: 'FO', viewValue: 'Faroe Islands', symbolBefore: true
      },
      {
        value: 'FR', viewValue: 'France', symbolBefore: true
      },
      {
        value: 'GA', viewValue: 'Gabon', symbolBefore: true
      },
      {
        value: 'GB', viewValue: 'United Kingdom of Great Britain and Northern Ireland', symbolBefore: true
      },
      {
        value: 'GD', viewValue: 'Grenada', symbolBefore: true
      },
      {
        value: 'GE', viewValue: 'Georgia', symbolBefore: true
      },
      {
        value: 'GF', viewValue: 'French Guiana', symbolBefore: true
      },
      {
        value: 'GG', viewValue: 'Guernsey', symbolBefore: true
      },
      {
        value: 'GH', viewValue: 'Ghana', symbolBefore: true
      },
      {
        value: 'GI', viewValue: 'Gibraltar', symbolBefore: true
      },
      {
        value: 'GL', viewValue: 'Greenland', symbolBefore: true
      },
      {
        value: 'GM', viewValue: 'Gambia', symbolBefore: true
      },
      {
        value: 'GN', viewValue: 'Guinea', symbolBefore: true
      },
      {
        value: 'GP', viewValue: 'Guadeloupe', symbolBefore: true
      },
      {
        value: 'GQ', viewValue: 'Equatorial Guinea', symbolBefore: true
      },
      {
        value: 'GR', viewValue: 'Greece', symbolBefore: true
      },
      {
        value: 'GS', viewValue: 'South Georgia and the South Sandwich Islands', symbolBefore: true
      },
      {
        value: 'GT', viewValue: 'Guatemala', symbolBefore: true
      },
      {
        value: 'GU', viewValue: 'Guam', symbolBefore: true
      },
      {
        value: 'GW', viewValue: 'Guinea-Bissau', symbolBefore: true
      },
      {
        value: 'GY', viewValue: 'Guyana', symbolBefore: true
      },
      {
        value: 'HK', viewValue: 'Hong Kong', symbolBefore: true
      },
      {
        value: 'HM', viewValue: 'Heard Island and McDonald Islands', symbolBefore: true
      },
      {
        value: 'HN', viewValue: 'Honduras', symbolBefore: true
      },
      {
        value: 'HR', viewValue: 'Croatia', symbolBefore: true
      },
      {
        value: 'HT', viewValue: 'Haiti', symbolBefore: true
      },
      {
        value: 'HU', viewValue: 'Hungary', symbolBefore: true
      },
      {
        value: 'ID', viewValue: 'Indonesia', symbolBefore: true
      },
      {
        value: 'IE', viewValue: 'Ireland', symbolBefore: true
      },
      {
        value: 'IL', viewValue: 'Israel', symbolBefore: true
      },
      {
        value: 'IM', viewValue: 'Isle of Man', symbolBefore: true
      },
      {
        value: 'IN', viewValue: 'India', symbolBefore: true
      },
      {
        value: 'IO', viewValue: 'British Indian Ocean Territory', symbolBefore: true
      },
      {
        value: 'IQ', viewValue: 'Iraq', symbolBefore: true
      },
      {
        value: 'IR', viewValue: 'Iran, Islamic Republic of', symbolBefore: true
      },
      {
        value: 'IS', viewValue: 'Iceland', symbolBefore: true
      },
      {
        value: 'IT', viewValue: 'Italy', symbolBefore: true
      },
      {
        value: 'JE', viewValue: 'Jersey', symbolBefore: true
      },
      {
        value: 'JM', viewValue: 'Jamaica', symbolBefore: true
      },
      {
        value: 'JO', viewValue: 'Jordan', symbolBefore: true
      },
      {
        value: 'JP', viewValue: 'Japan', symbolBefore: true
      },
      {
        value: 'KE', viewValue: 'Kenya', symbolBefore: true
      },
      {
        value: 'KG', viewValue: 'Kyrgyzstan', symbolBefore: true
      },
      {
        value: 'KH', viewValue: 'Cambodia', symbolBefore: true
      },
      {
        value: 'KI', viewValue: 'Kiribati', symbolBefore: true
      },
      {
        value: 'KM', viewValue: 'Comoros', symbolBefore: true
      },
      {
        value: 'KN', viewValue: 'Saint Kitts and Nevis', symbolBefore: true
      },
      {
        value: 'KP', viewValue: 'North Korea', symbolBefore: true
      },
      {
        value: 'KR', viewValue: 'South Korea', symbolBefore: true
      },
      {
        value: 'KW', viewValue: 'Kuwait', symbolBefore: true
      },
      {
        value: 'KY', viewValue: 'Cayman Islands', symbolBefore: true
      },
      {
        value: 'KZ', viewValue: 'Kazakhstan', symbolBefore: true
      },
      {
        value: 'LA', viewValue: 'Laos', symbolBefore: true
      },
      {
        value: 'LB', viewValue: 'Lebanon', symbolBefore: true
      },
      {
        value: 'LC', viewValue: 'Saint Lucia', symbolBefore: true
      },
      {
        value: 'LI', viewValue: 'Liechtenstein', symbolBefore: true
      },
      {
        value: 'LK', viewValue: 'Sri Lanka', symbolBefore: true
      },
      {
        value: 'LR', viewValue: 'Liberia', symbolBefore: true
      },
      {
        value: 'LS', viewValue: 'Lesotho', symbolBefore: true
      },
      {
        value: 'LT', viewValue: 'Lithuania', symbolBefore: true
      },
      {
        value: 'LU', viewValue: 'Luxembourg', symbolBefore: true
      },
      {
        value: 'LV', viewValue: 'Latvia', symbolBefore: true
      },
      {
        value: 'LY', viewValue: 'Libya', symbolBefore: true
      },
      {
        value: 'MA', viewValue: 'Morocco', symbolBefore: true
      },
      {
        value: 'MC', viewValue: 'Monaco', symbolBefore: true
      },
      {
        value: 'MD', viewValue: 'Moldova', symbolBefore: true
      },
      {
        value: 'ME', viewValue: 'Montenegro', symbolBefore: true
      },
      {
        value: 'MF', viewValue: 'Saint Martin', symbolBefore: true
      },
      {
        value: 'MG', viewValue: 'Madagascar', symbolBefore: true
      },
      {
        value: 'MH', viewValue: 'Marshall Islands', symbolBefore: true
      },
      {
        value: 'MK', viewValue: 'Macedonia', symbolBefore: true
      },
      {
        value: 'ML', viewValue: 'Mali', symbolBefore: true
      },
      {
        value: 'MM', viewValue: 'Myanmar', symbolBefore: true
      },
      {
        value: 'MN', viewValue: 'Mongolia', symbolBefore: true
      },
      {
        value: 'MO', viewValue: 'Macao', symbolBefore: true
      },
      {
        value: 'MP', viewValue: 'Northern Mariana Islands', symbolBefore: true
      },
      {
        value: 'MQ', viewValue: 'Martinique', symbolBefore: true
      },
      {
        value: 'MR', viewValue: 'Mauritania', symbolBefore: true
      },
      {
        value: 'MS', viewValue: 'Montserrat', symbolBefore: true
      },
      {
        value: 'MT', viewValue: 'Malta', symbolBefore: true
      },
      {
        value: 'MU', viewValue: 'Mauritius', symbolBefore: true
      },
      {
        value: 'MV', viewValue: 'Maldives', symbolBefore: true
      },
      {
        value: 'MW', viewValue: 'Malawi', symbolBefore: true
      },
      {
        value: 'MX', viewValue: 'Mexico', symbolBefore: true
      },
      {
        value: 'MY', viewValue: 'Malaysia', symbolBefore: true
      },
      {
        value: 'MZ', viewValue: 'Mozambique', symbolBefore: true
      },
      {
        value: 'NA', viewValue: 'Namibia', symbolBefore: true
      },
      {
        value: 'NC', viewValue: 'New Caledonia', symbolBefore: true
      },
      {
        value: 'NE', viewValue: 'Niger', symbolBefore: true
      },
      {
        value: 'NF', viewValue: 'Norfolk Island', symbolBefore: true
      },
      {
        value: 'NG', viewValue: 'Nigeria', symbolBefore: true
      },
      {
        value: 'NI', viewValue: 'Nicaragua', symbolBefore: true
      },
      {
        value: 'NL', viewValue: 'Netherlands', symbolBefore: true
      },
      {
        value: 'NO', viewValue: 'Norway', symbolBefore: true
      },
      {
        value: 'NP', viewValue: 'Nepal', symbolBefore: true
      },
      {
        value: 'NR', viewValue: 'Nauru', symbolBefore: true
      },
      {
        value: 'NU', viewValue: 'Niue', symbolBefore: true
      },
      {
        value: 'NZ', viewValue: 'New Zealand', symbolBefore: true
      },
      {
        value: 'OM', viewValue: 'Oman', symbolBefore: true
      },
      {
        value: 'PA', viewValue: 'Panama', symbolBefore: true
      },
      {
        value: 'PE', viewValue: 'Peru', symbolBefore: true
      },
      {
        value: 'PF', viewValue: 'French Polynesia', symbolBefore: true
      },
      {
        value: 'PG', viewValue: 'Papua New Guinea', symbolBefore: true
      },
      {
        value: 'PH', viewValue: 'Philippines', symbolBefore: true
      },
      {
        value: 'PK', viewValue: 'Pakistan', symbolBefore: true
      },
      {
        value: 'PL', viewValue: 'Poland', symbolBefore: true
      },
      {
        value: 'PM', viewValue: 'Saint Pierre and Miquelon', symbolBefore: true
      },
      {
        value: 'PN', viewValue: 'Pitcairn', symbolBefore: true
      },
      {
        value: 'PR', viewValue: 'Puerto Rico', symbolBefore: true
      },
      {
        value: 'PS', viewValue: 'Palestine', symbolBefore: true
      },
      {
        value: 'PT', viewValue: 'Portugal', symbolBefore: true
      },
      {
        value: 'PW', viewValue: 'Palau', symbolBefore: true
      },
      {
        value: 'PY', viewValue: 'Paraguay', symbolBefore: true
      },
      {
        value: 'QA', viewValue: 'Qatar', symbolBefore: true
      },
      {
        value: 'RE', viewValue: 'Réunion', symbolBefore: true
      },
      {
        value: 'RO', viewValue: 'Romania', symbolBefore: true
      },
      {
        value: 'RS', viewValue: 'Serbia', symbolBefore: true
      },
      {
        value: 'RU', viewValue: 'Russia', symbolBefore: true
      },
      {
        value: 'RW', viewValue: 'Rwanda', symbolBefore: true
      },
      {
        value: 'SA', viewValue: 'Saudi Arabia', symbolBefore: true
      },
      {
        value: 'SB', viewValue: 'Solomon Islands', symbolBefore: true
      },
      {
        value: 'SC', viewValue: 'Seychelles', symbolBefore: true
      },
      {
        value: 'SD', viewValue: 'Sudan', symbolBefore: true
      },
      {
        value: 'SE', viewValue: 'Sweden', symbolBefore: true
      },
      {
        value: 'SG', viewValue: 'Singapore', symbolBefore: true
      },
      {
        value: 'SH', viewValue: 'Saint Helena', symbolBefore: true
      },
      {
        value: 'SI', viewValue: 'Slovenia', symbolBefore: true
      },
      {
        value: 'SJ', viewValue: 'Svalbard and Jan Mayen', symbolBefore: true
      },
      {
        value: 'SK', viewValue: 'Slovakia', symbolBefore: true
      },
      {
        value: 'SL', viewValue: 'Sierra Leone', symbolBefore: true
      },
      {
        value: 'SM', viewValue: 'San Marino', symbolBefore: true
      },
      {
        value: 'SN', viewValue: 'Senegal', symbolBefore: true
      },
      {
        value: 'SO', viewValue: 'Somalia', symbolBefore: true
      },
      {
        value: 'SR', viewValue: 'Suriname', symbolBefore: true
      },
      {
        value: 'SS', viewValue: 'South Sudan', symbolBefore: true
      },
      {
        value: 'ST', viewValue: 'Sao Tome and Principe', symbolBefore: true
      },
      {
        value: 'SV', viewValue: 'El Salvador', symbolBefore: true
      },
      {
        value: 'SX', viewValue: 'Sint Maarten', symbolBefore: true
      },
      {
        value: 'SY', viewValue: 'Syria', symbolBefore: true
      },
      {
        value: 'SZ', viewValue: 'Swaziland', symbolBefore: true
      },
      {
        value: 'TC', viewValue: 'Turks and Caicos Islands', symbolBefore: true
      },
      {
        value: 'TD', viewValue: 'Chad', symbolBefore: true
      },
      {
        value: 'TF', viewValue: 'French Southern Territories', symbolBefore: true
      },
      {
        value: 'TG', viewValue: 'Togo', symbolBefore: true
      },
      {
        value: 'TH', viewValue: 'Thailand', symbolBefore: true
      },
      {
        value: 'TJ', viewValue: 'Tajikistan', symbolBefore: true
      },
      {
        value: 'TK', viewValue: 'Tokelau', symbolBefore: true
      },
      {
        value: 'TL', viewValue: 'East Timor', symbolBefore: true
      },
      {
        value: 'TM', viewValue: 'Turkmenistan', symbolBefore: true
      },
      {
        value: 'TN', viewValue: 'Tunisia', symbolBefore: true
      },
      {
        value: 'TO', viewValue: 'Tonga', symbolBefore: true
      },
      {
        value: 'TR', viewValue: 'Turkey', symbolBefore: true
      },
      {
        value: 'TT', viewValue: 'Trinidad and Tobago', symbolBefore: true
      },
      {
        value: 'TV', viewValue: 'Tuvalu', symbolBefore: true
      },
      {
        value: 'TW', viewValue: 'Taiwan', symbolBefore: true
      },
      {
        value: 'TZ', viewValue: 'Tanzania', symbolBefore: true
      },
      {
        value: 'UA', viewValue: 'Ukraine', symbolBefore: true
      },
      {
        value: 'UG', viewValue: 'Uganda', symbolBefore: true
      },
      {
        value: 'UM', viewValue: 'United States Minor Outlying Islands', symbolBefore: true
      },
      {
        value: 'US', viewValue: 'United States of America', symbolBefore: true
      },
      {
        value: 'UY', viewValue: 'Uruguay', symbolBefore: true
      },
      {
        value: 'UZ', viewValue: 'Uzbekistan', symbolBefore: true
      },
      {
        value: 'VA', viewValue: 'Vatican', symbolBefore: true
      },
      {
        value: 'VC', viewValue: 'Saint Vincent and the Grenadines', symbolBefore: true
      },
      {
        value: 'VE', viewValue: 'Venezuela', symbolBefore: true
      },
      {
        value: 'VG', viewValue: 'Virgin Islands, British', symbolBefore: true
      },
      {
        value: 'VI', viewValue: 'Virgin Islands, U.S.', symbolBefore: true
      },
      {
        value: 'VN', viewValue: 'Vietnam', symbolBefore: true
      },
      {
        value: 'VU', viewValue: 'Vanuatu', symbolBefore: true
      },
      {
        value: 'WF', viewValue: 'Wallis and Futuna', symbolBefore: true
      },
      {
        value: 'WS', viewValue: 'Samoa', symbolBefore: true
      },
      {
        value: 'YE', viewValue: 'Yemen', symbolBefore: true
      },
      {
        value: 'YT', viewValue: 'Mayotte', symbolBefore: true
      },
      {
        value: 'ZA', viewValue: 'South Africa', symbolBefore: true
      },
      {
        value: 'ZM', viewValue: 'Zambia', symbolBefore: true
      },
      { value: 'ZW', viewValue: 'Zimbabwe' }
    ];
  }

  getCountriesN() {
    return [
      {
        value: 'AM', name: 'Armenia'
      },
      {
        value: 'AO', name: 'Angola'
      },
      {
        value: 'AQ', name: 'Antarctica'
      },
      {
        value: 'AD', name: 'Andorra'
      },
      {
        value: 'AR', name: 'Argentina'
      },
      {
        value: 'AS', name: 'American Samoa'
      },
      {
        value: 'AT', name: 'Austria'
      },
      {
        value: 'AU', name: 'Australia'
      },
      {
        value: 'AW', name: 'Aruba'
      },
      {
        value: 'AX', name: 'Åland Islands'
      },
      {
        value: 'AZ', name: 'Azerbaijan'
      },
      {
        value: 'BA', name: 'Bosnia and Herzegovina'
      },
      {
        value: 'BB', name: 'Barbados'
      },
      {
        value: 'BD', name: 'Bangladesh'
      },
      {
        value: 'BE', name: 'Belgium'
      },
      {
        value: 'BF', name: 'Burkina Faso'
      },
      {
        value: 'BG', name: 'Bulgaria'
      },
      {
        value: 'BH', name: 'Bahrain'
      },
      {
        value: 'BI', name: 'Burundi'
      },
      {
        value: 'BJ', name: 'Benin'
      },
      {
        value: 'BL', name: 'Saint Barthélemy'
      },
      {
        value: 'BM', name: 'Bermuda'
      },
      {
        value: 'BN', name: 'Brunei Darussalam'
      },
      {
        value: 'BO', name: 'Bolivia'
      },
      {
        value: 'BQ', name: 'Bonaire'
      },
      {
        value: 'BR', name: 'Brazil'
      },
      {
        value: 'BS', name: 'Bahamas'
      },
      {
        value: 'BT', name: 'Bhutan'
      },
      {
        value: 'BV', name: 'Bouvet Island'
      },
      {
        value: 'BW', name: 'Botswana'
      },
      {
        value: 'BY', name: 'Belarus'
      },
      {
        value: 'BZ', name: 'Belize'
      },
      {
        value: 'CA', name: 'Canada'
      },
      {
        value: 'CC', name: 'Cocos Islands'
      },
      {
        value: 'CD', name: 'Democratic Republic of the Congo'
      },
      {
        value: 'CF', name: 'Central African Republic'
      },
      {
        value: 'CG', name: 'Congo'
      },
      {
        value: 'CH', name: 'Switzerland'
      },
      {
        value: 'CI', name: 'Ivory Coast'
      },
      {
        value: 'CK', name: 'Cook Islands'
      },
      {
        value: 'CL', name: 'Chile'
      },
      {
        value: 'CM', name: 'Cameroon'
      },
      {
        value: 'CN', name: 'China'
      },
      {
        value: 'CO', name: 'Colombia'
      },
      {
        value: 'CR', name: 'Costa Rica'
      },
      {
        value: 'CU', name: 'Cuba'
      },
      {
        value: 'CV', name: 'Cabo Verde'
      },
      {
        value: 'CW', name: 'Curaçao'
      },
      {
        value: 'CX', name: 'Christmas Island'
      },
      {
        value: 'CY', name: 'Cyprus'
      },
      {
        value: 'CZ', name: 'Czechia'
      },
      {
        value: 'DE', name: 'Germany'
      },
      {
        value: 'DJ', name: 'Djibouti'
      },
      {
        value: 'DK', name: 'Denmark'
      },
      {
        value: 'DM', name: 'Dominica'
      },
      {
        value: 'DO', name: 'Dominican Republic'
      },
      {
        value: 'DZ', name: 'Algeria'
      },
      {
        value: 'EC', name: 'Ecuador'
      },
      {
        value: 'EE', name: 'Estonia'
      },
      {
        value: 'EG', name: 'Egypt'
      },
      {
        value: 'EH', name: 'Western Sahara'
      },
      {
        value: 'ER', name: 'Eritrea'
      },
      {
        value: 'ES', name: 'Spain'
      },
      {
        value: 'ET', name: 'Ethiopia'
      },
      {
        value: 'FI', name: 'Finland'
      },
      {
        value: 'FJ', name: 'Fiji'
      },
      {
        value: 'FK', name: 'Falkland Islands (Malvinas)'
      },
      {
        value: 'FM', name: 'Micronesia, Federated States of'
      },
      {
        value: 'FO', name: 'Faroe Islands'
      },
      {
        value: 'FR', name: 'France'
      },
      {
        value: 'GA', name: 'Gabon'
      },
      {
        value: 'GB', name: 'United Kingdom of Great Britain and Northern Ireland'
      },
      {
        value: 'GD', name: 'Grenada'
      },
      {
        value: 'GE', name: 'Georgia'
      },
      {
        value: 'GF', name: 'French Guiana'
      },
      {
        value: 'GG', name: 'Guernsey'
      },
      {
        value: 'GH', name: 'Ghana'
      },
      {
        value: 'GI', name: 'Gibraltar'
      },
      {
        value: 'GL', name: 'Greenland'
      },
      {
        value: 'GM', name: 'Gambia'
      },
      {
        value: 'GN', name: 'Guinea'
      },
      {
        value: 'GP', name: 'Guadeloupe'
      },
      {
        value: 'GQ', name: 'Equatorial Guinea'
      },
      {
        value: 'GR', name: 'Greece'
      },
      {
        value: 'GS', name: 'South Georgia and the South Sandwich Islands'
      },
      {
        value: 'GT', name: 'Guatemala'
      },
      {
        value: 'GU', name: 'Guam'
      },
      {
        value: 'GW', name: 'Guinea-Bissau'
      },
      {
        value: 'GY', name: 'Guyana'
      },
      {
        value: 'HK', name: 'Hong Kong'
      },
      {
        value: 'HM', name: 'Heard Island and McDonald Islands'
      },
      {
        value: 'HN', name: 'Honduras'
      },
      {
        value: 'HR', name: 'Croatia'
      },
      {
        value: 'HT', name: 'Haiti'
      },
      {
        value: 'HU', name: 'Hungary'
      },
      {
        value: 'ID', name: 'Indonesia'
      },
      {
        value: 'IE', name: 'Ireland'
      },
      {
        value: 'IL', name: 'Israel'
      },
      {
        value: 'IM', name: 'Isle of Man'
      },
      {
        value: 'IN', name: 'India'
      },
      {
        value: 'IO', name: 'British Indian Ocean Territory'
      },
      {
        value: 'IQ', name: 'Iraq'
      },
      {
        value: 'IR', name: 'Iran, Islamic Republic of'
      },
      {
        value: 'IS', name: 'Iceland'
      },
      {
        value: 'IT', name: 'Italy'
      },
      {
        value: 'JE', name: 'Jersey'
      },
      {
        value: 'JM', name: 'Jamaica'
      },
      {
        value: 'JO', name: 'Jordan'
      },
      {
        value: 'JP', name: 'Japan'
      },
      {
        value: 'KE', name: 'Kenya'
      },
      {
        value: 'KG', name: 'Kyrgyzstan'
      },
      {
        value: 'KH', name: 'Cambodia'
      },
      {
        value: 'KI', name: 'Kiribati'
      },
      {
        value: 'KM', name: 'Comoros'
      },
      {
        value: 'KN', name: 'Saint Kitts and Nevis'
      },
      {
        value: 'KP', name: 'North Korea'
      },
      {
        value: 'KR', name: 'South Korea'
      },
      {
        value: 'KW', name: 'Kuwait'
      },
      {
        value: 'KY', name: 'Cayman Islands'
      },
      {
        value: 'KZ', name: 'Kazakhstan'
      },
      {
        value: 'LA', name: 'Laos'
      },
      {
        value: 'LB', name: 'Lebanon'
      },
      {
        value: 'LC', name: 'Saint Lucia'
      },
      {
        value: 'LI', name: 'Liechtenstein'
      },
      {
        value: 'LK', name: 'Sri Lanka'
      },
      {
        value: 'LR', name: 'Liberia'
      },
      {
        value: 'LS', name: 'Lesotho'
      },
      {
        value: 'LT', name: 'Lithuania'
      },
      {
        value: 'LU', name: 'Luxembourg'
      },
      {
        value: 'LV', name: 'Latvia'
      },
      {
        value: 'LY', name: 'Libya'
      },
      {
        value: 'MA', name: 'Morocco'
      },
      {
        value: 'MC', name: 'Monaco'
      },
      {
        value: 'MD', name: 'Moldova'
      },
      {
        value: 'ME', name: 'Montenegro'
      },
      {
        value: 'MF', name: 'Saint Martin'
      },
      {
        value: 'MG', name: 'Madagascar'
      },
      {
        value: 'MH', name: 'Marshall Islands'
      },
      {
        value: 'MK', name: 'Macedonia'
      },
      {
        value: 'ML', name: 'Mali'
      },
      {
        value: 'MM', name: 'Myanmar'
      },
      {
        value: 'MN', name: 'Mongolia'
      },
      {
        value: 'MO', name: 'Macao'
      },
      {
        value: 'MP', name: 'Northern Mariana Islands'
      },
      {
        value: 'MQ', name: 'Martinique'
      },
      {
        value: 'MR', name: 'Mauritania'
      },
      {
        value: 'MS', name: 'Montserrat'
      },
      {
        value: 'MT', name: 'Malta'
      },
      {
        value: 'MU', name: 'Mauritius'
      },
      {
        value: 'MV', name: 'Maldives'
      },
      {
        value: 'MW', name: 'Malawi'
      },
      {
        value: 'MX', name: 'Mexico'
      },
      {
        value: 'MY', name: 'Malaysia'
      },
      {
        value: 'MZ', name: 'Mozambique'
      },
      {
        value: 'NA', name: 'Namibia'
      },
      {
        value: 'NC', name: 'New Caledonia'
      },
      {
        value: 'NE', name: 'Niger'
      },
      {
        value: 'NF', name: 'Norfolk Island'
      },
      {
        value: 'NG', name: 'Nigeria'
      },
      {
        value: 'NI', name: 'Nicaragua'
      },
      {
        value: 'NL', name: 'Netherlands'
      },
      {
        value: 'NO', name: 'Norway'
      },
      {
        value: 'NP', name: 'Nepal'
      },
      {
        value: 'NR', name: 'Nauru'
      },
      {
        value: 'NU', name: 'Niue'
      },
      {
        value: 'NZ', name: 'New Zealand'
      },
      {
        value: 'OM', name: 'Oman'
      },
      {
        value: 'PA', name: 'Panama'
      },
      {
        value: 'PE', name: 'Peru'
      },
      {
        value: 'PF', name: 'French Polynesia'
      },
      {
        value: 'PG', name: 'Papua New Guinea'
      },
      {
        value: 'PH', name: 'Philippines'
      },
      {
        value: 'PK', name: 'Pakistan'
      },
      {
        value: 'PL', name: 'Poland'
      },
      {
        value: 'PM', name: 'Saint Pierre and Miquelon'
      },
      {
        value: 'PN', name: 'Pitcairn'
      },
      {
        value: 'PR', name: 'Puerto Rico'
      },
      {
        value: 'PS', name: 'Palestine'
      },
      {
        value: 'PT', name: 'Portugal'
      },
      {
        value: 'PW', name: 'Palau'
      },
      {
        value: 'PY', name: 'Paraguay'
      },
      {
        value: 'QA', name: 'Qatar'
      },
      {
        value: 'RE', name: 'Réunion'
      },
      {
        value: 'RO', name: 'Romania'
      },
      {
        value: 'RS', name: 'Serbia'
      },
      {
        value: 'RU', name: 'Russia'
      },
      {
        value: 'RW', name: 'Rwanda'
      },
      {
        value: 'SA', name: 'Saudi Arabia'
      },
      {
        value: 'SB', name: 'Solomon Islands'
      },
      {
        value: 'SC', name: 'Seychelles'
      },
      {
        value: 'SD', name: 'Sudan'
      },
      {
        value: 'SE', name: 'Sweden'
      },
      {
        value: 'SG', name: 'Singapore'
      },
      {
        value: 'SH', name: 'Saint Helena'
      },
      {
        value: 'SI', name: 'Slovenia'
      },
      {
        value: 'SJ', name: 'Svalbard and Jan Mayen'
      },
      {
        value: 'SK', name: 'Slovakia'
      },
      {
        value: 'SL', name: 'Sierra Leone'
      },
      {
        value: 'SM', name: 'San Marino'
      },
      {
        value: 'SN', name: 'Senegal'
      },
      {
        value: 'SO', name: 'Somalia'
      },
      {
        value: 'SR', name: 'Suriname'
      },
      {
        value: 'SS', name: 'South Sudan'
      },
      {
        value: 'ST', name: 'Sao Tome and Principe'
      },
      {
        value: 'SV', name: 'El Salvador'
      },
      {
        value: 'SX', name: 'Sint Maarten'
      },
      {
        value: 'SY', name: 'Syria'
      },
      {
        value: 'SZ', name: 'Swaziland'
      },
      {
        value: 'TC', name: 'Turks and Caicos Islands'
      },
      {
        value: 'TD', name: 'Chad'
      },
      {
        value: 'TF', name: 'French Southern Territories'
      },
      {
        value: 'TG', name: 'Togo'
      },
      {
        value: 'TH', name: 'Thailand'
      },
      {
        value: 'TJ', name: 'Tajikistan'
      },
      {
        value: 'TK', name: 'Tokelau'
      },
      {
        value: 'TL', name: 'East Timor'
      },
      {
        value: 'TM', name: 'Turkmenistan'
      },
      {
        value: 'TN', name: 'Tunisia'
      },
      {
        value: 'TO', name: 'Tonga'
      },
      {
        value: 'TR', name: 'Turkey'
      },
      {
        value: 'TT', name: 'Trinidad and Tobago'
      },
      {
        value: 'TV', name: 'Tuvalu'
      },
      {
        value: 'TW', name: 'Taiwan'
      },
      {
        value: 'TZ', name: 'Tanzania'
      },
      {
        value: 'UA', name: 'Ukraine'
      },
      {
        value: 'UG', name: 'Uganda'
      },
      {
        value: 'UM', name: 'United States Minor Outlying Islands'
      },
      {
        value: 'US', name: 'United States of America'
      },
      {
        value: 'UY', name: 'Uruguay'
      },
      {
        value: 'UZ', name: 'Uzbekistan'
      },
      {
        value: 'VA', name: 'Vatican'
      },
      {
        value: 'VC', name: 'Saint Vincent and the Grenadines'
      },
      {
        value: 'VE', name: 'Venezuela'
      },
      {
        value: 'VG', name: 'Virgin Islands, British'
      },
      {
        value: 'VI', name: 'Virgin Islands, U.S.'
      },
      {
        value: 'VN', name: 'Vietnam'
      },
      {
        value: 'VU', name: 'Vanuatu'
      },
      {
        value: 'WF', name: 'Wallis and Futuna'
      },
      {
        value: 'WS', name: 'Samoa'
      },
      {
        value: 'YE', name: 'Yemen'
      },
      {
        value: 'YT', name: 'Mayotte'
      },
      {
        value: 'ZA', name: 'South Africa'
      },
      {
        value: 'ZM', name: 'Zambia'
      },
      { value: 'ZW', name: 'Zimbabwe' }
    ];
  }

  getCountryToContinent(country: string): string {
    let continent = '';
    switch (country) {
      case 'DE':
      case 'GG':
      case 'VA':
      case 'HU':
      case 'IS':
      case 'IE':
      case 'IM':
      case 'IT':
      case 'JE':
      case 'LV':
      case 'LI':
      case 'LT':
      case 'LU':
      case 'MK':
      case 'MT':
      case 'MD':
      case 'MC':
      case 'ME':
      case 'NL':
      case 'NO':
      case 'RO':
      case 'RU':
      case 'RS':
      case 'SK':
      case 'SI':
      case 'ES':
      case 'SJ':
      case 'SE':
      case 'CH':
      case 'UA':
      case 'GB':
      case 'GI':
      case 'GR':
      case 'AX':
      case 'AL':
      case 'AD':
      case 'AT':
      case 'BA':
      case 'BY':
      case 'BE':
      case 'BG':
      case 'CZ':
      case 'DK':
      case 'EE':
      case 'HR':
      case 'FI':
      case 'FR':
      case 'FO':
      case 'PL':
      case 'PT':
      case 'SM':
        continent = 'EU';
        break;

      case 'GH':
      case 'DZ':
      case 'AO':
      case 'BJ':
      case 'BW':
      case 'BF':
      case 'BI':
      case 'CM':
      case 'CV':
      case 'CF':
      case 'TD':
      case 'KM':
      case 'CD':
      case 'CG':
      case 'CI':
      case 'DJ':
      case 'EG':
      case 'GQ':
      case 'ER':
      case 'ET':
      case 'GA':
      case 'GM':
      case 'GN':
      case 'GW':
      case 'KE':
      case 'LS':
      case 'LR':
      case 'LY':
      case 'MG':
      case 'MW':
      case 'ML':
      case 'MR':
      case 'MU':
      case 'YT':
      case 'MA':
      case 'MZ':
      case 'NA':
      case 'NE':
      case 'NG':
      case 'RE':
      case 'RW':
      case 'SH':
      case 'ST':
      case 'SN':
      case 'SC':
      case 'SL':
      case 'SO':
      case 'ZA':
      case 'SD':
      case 'SZ':
      case 'TZ':
      case 'TG':
      case 'TN':
      case 'UG':
      case 'EH':
      case 'ZM':
      case 'ZW':
        continent = 'AF';

        break;

      case 'AF':
      case 'AM':
      case 'AZ':
      case 'BH':
      case 'BD':
      case 'BT':
      case 'IO':
      case 'BN':
      case 'KH':
      case 'CN':
      case 'CX':
      case 'CC':
      case 'CY':
      case 'GE':
      case 'HK':
      case 'IN':
      case 'ID':
      case 'IR':
      case 'IQ':
      case 'IL':
      case 'JP':
      case 'JO':
      case 'KZ':
      case 'KP':
      case 'KR':
      case 'KW':
      case 'KG':
      case 'LA':
      case 'LB':
      case 'MO':
      case 'MY':
      case 'MV':
      case 'MN':
      case 'MM':
      case 'NP':
      case 'OM':
      case 'PK':
      case 'PS':
      case 'PH':
      case 'QA':
      case 'SA':
      case 'SG':
      case 'LK':
      case 'SY':
      case 'TW':
      case 'TJ':
      case 'TH':
      case 'TL':
      case 'TR':
      case 'TM':
      case 'AE':
      case 'UZ':
      case 'VN':
      case 'YE':
        continent = 'AS';
        break;

      case 'AU':
      case 'AS':
      case 'CK':
      case 'FJ':
      case 'PF':
      case 'GU':
      case 'KI':
      case 'MH':
      case 'FM':
      case 'NR':
      case 'NC':
      case 'NZ':
      case 'NU':
      case 'NF':
      case 'MP':
      case 'PW':
      case 'PG':
      case 'PN':
      case 'WS':
      case 'SB':
      case 'TK':
      case 'TO':
      case 'TV':
      case 'UM':
      case 'VU':
      case 'WF':
        continent = 'OC';
        break;

      case 'AQ':
      case 'BV':
      case 'TF':
      case 'HM':
      case 'GS':
        continent = 'AN';
        break;

      case 'AI':
      case 'AW':
      case 'AG':
      case 'BS':
      case 'BB':
      case 'BZ':
      case 'BM':
      case 'CA':
      case 'KY':
      case 'VG':
      case 'CR':
      case 'CU':
      case 'DM':
      case 'DO':
      case 'SV':
      case 'GL':
      case 'GD':
      case 'GP':
      case 'GT':
      case 'HT':
      case 'HN':
      case 'JM':
      case 'MQ':
      case 'MX':
      case 'MS':
      case 'NI':
      case 'PA':
      case 'PR':
      case 'BL':
      case 'KN':
      case 'LC':
      case 'MF':
      case 'PM':
      case 'VC':
      case 'AN':
      case 'TT':
      case 'TC':
      case 'US':
      case 'VI':
        continent = 'NA';
        break;

      case 'AR':
      case 'BO':
      case 'CL':
      case 'CO':
      case 'BR':
      case 'EC':
      case 'FK':
      case 'GF':
      case 'GY':
      case 'PY':
      case 'PE':
      case 'SR':
      case 'UY':
      case 'VE':
        continent = 'SA';
        break;
    }

    return continent;
  }

  getEuropeanUnionCountries(): { name: string, value: string }[] {
    return [
      { name: 'Austria', value: 'AT' },
      { name: 'Belgium', value: 'BE' },
      { name: 'Bulgaria', value: 'BBG' },
      { name: 'Cyprus', value: 'CY' },
      { name: 'Czech Republic', value: 'CZ' },
      { name: 'Denmark', value: 'DK' },
      { name: 'Estonia', value: 'EE' },
      { name: 'Finland', value: 'FI' },
      { name: 'France', value: 'FR' },
      { name: 'Germany', value: 'DE' },
      { name: 'Greece', value: 'GR' },
      { name: 'Hungary', value: 'HU' },
      { name: 'Ireland', value: 'IE' },
      { name: 'Italy', value: 'IT' },
      { name: 'Latvia', value: 'LV' },
      { name: 'Luxembourg', value: 'LU' },
      { name: 'Lithuania', value: 'LT' },
      { name: 'Malta', value: 'MT' },
      { name: 'Netherlands', value: 'NL' },
      { name: 'Poland', value: 'PL' },
      { name: 'Portugal', value: 'PT' },
      { name: 'Romania', value: 'RO' },
      { name: 'Slovakia', value: 'SK' },
      { name: 'Slovenia', value: 'SI' },
      { name: 'Spain', value: 'ES' },
      { name: 'Sweden', value: 'SE' }
    ];
  }
  getCanadianProvinces() {
    return [
      { value: 'AB', name: 'Alberta' },
      { value: 'BC', name: 'British_Columbia' },
      { value: 'MB', name: 'Manitoba' },
      { value: 'NB', name: 'New_Brunswick' },
      { value: 'NL', name: 'Newfoundland_and_Labrador' },
      { value: 'NS', name: 'Nova_Scotia' },
      { value: 'NT', name: 'Northwest_Territories' },
      { value: 'NU', name: 'Nunavut' },
      { value: 'ON', name: 'Ontario' },
      { value: 'PE', name: 'Prince_Edward_Island' },
      { value: 'QC', name: 'Quebec' },
      { value: 'SK', name: 'Saskatchewan' },
      { value: 'YT', name: 'Yukon' },
    ];
  }

  getAmericanStates() {

    return [
      { value: 'AL', name: 'Alabama' },
      { value: 'AK', name: 'Alaska' },
      { value: 'AS', name: 'American_Samoa' },
      { value: 'AZ', name: 'Arizona' },
      { value: 'AR', name: 'Arkansas' },
      { value: 'CA', name: 'California' },
      { value: 'CO', name: 'Colorado' },
      { value: 'CT', name: 'Connecticut' },
      { value: 'DE', name: 'Delaware' },
      { value: 'DC', name: 'District_Of_Columbia' },
      { value: 'FM', name: 'Federated_States_Of_Micronesia' },
      { value: 'FL', name: 'Florida' },
      { value: 'GA', name: 'Georgia' },
      { value: 'GU', name: 'Guam' },
      { value: 'HI', name: 'Hawaii' },
      { value: 'ID', name: 'Idaho' },
      { value: 'IL', name: 'Illinois' },
      { value: 'IN', name: 'Indiana' },
      { value: 'IA', name: 'Iowa' },
      { value: 'KS', name: 'Kansas' },
      { value: 'KY', name: 'Kentucky' },
      { value: 'LA', name: 'Louisiana' },
      { value: 'ME', name: 'Maine' },
      { value: 'MH', name: 'Marshall_Islands' },
      { value: 'MD', name: 'Maryland' },
      { value: 'MA', name: 'Massachusetts' },
      { value: 'MI', name: 'Michigan' },
      { value: 'MN', name: 'Minnesota' },
      { value: 'MS', name: 'Mississippi' },
      { value: 'MO', name: 'Missouri' },
      { value: 'MT', name: 'Montana' },
      { value: 'NE', name: 'Nebraska' },
      { value: 'NV', name: 'Nevada' },
      { value: 'NH', name: 'New_Hampshire' },
      { value: 'NJ', name: 'New_Jersey' },
      { value: 'NM', name: 'New_Mexico' },
      { value: 'NY', name: 'New_York' },
      { value: 'NC', name: 'North_Carolina' },
      { value: 'ND', name: 'North_Dakota' },
      { value: 'MP', name: 'Northern_Mariana_Islands' },
      { value: 'OH', name: 'Ohio' },
      { value: 'OK', name: 'Oklahoma' },
      { value: 'OR', name: 'Oregon' },
      { value: 'PW', name: 'Palau' },
      { value: 'PA', name: 'Pennsylvania' },
      { value: 'PR', name: 'Puerto_Rico' },
      { value: 'RI', name: 'Rhode_Island' },
      { value: 'SC', name: 'South_Carolina' },
      { value: 'SD', name: 'South_Dakota' },
      { value: 'TN', name: 'Tennessee' },
      { value: 'TX', name: 'Texas' },
      { value: 'UT', name: 'Utah' },
      { value: 'VT', name: 'Vermont' },
      { value: 'VI', name: 'Virgin_Islands' },
      { value: 'VA', name: 'Virginia' },
      { value: 'WA', name: 'Washington' },
      { value: 'WV', name: 'West_Virginia' },
      { value: 'WI', name: 'Wisconsin' },
      { value: 'WY', name: 'Wyoming' }
    ];
  }


  getGemShapes() {
    return [
      {
        value: 'ROUND',
        viewValue: 'Round',
        icommon: 'icon-JEW_ROUND',
        icon: 'SHAPE_ROUND'
      },
      {
        value: 'CUSHION',
        viewValue: 'Cushion',
        icommon: 'icon-JEW_CUSHION',
        icon: 'SHAPE_CUSHION'
      },
      {
        value: 'PRINCESS',
        viewValue: 'Princess',
        icommon: 'icon-JEW_PRINCESS'
      },
      {
        value: 'EMERALD',
        viewValue: 'Emerald',
        icommon: 'icon-JEW_EMERALD'
      },
      {
        value: 'PEAR',
        viewValue: 'Pear',
        icommon: 'icon-JEW_PEARL'
      },
      {
        value: 'OVAL',
        viewValue: 'Oval',
        icommon: 'icon-JEW_OVAL'
      },
      {
        value: 'RADIANT',
        viewValue: 'Radiant',
        icommon: 'icon-JEW_RADIANT'
      },
      {
        value: 'ASSHCHER',
        viewValue: 'Asshcher',
        icommon: 'icon-JEW_ASSCHER'
      },
      {
        value: 'MARQUISE',
        viewValue: 'Marquise',
        icommon: 'icon-JEW_MARQUISE'
      },
      {
        value: 'HEART',
        viewValue: 'Heart',
        icommon: 'icon-JEW_HEART'
      },
    ];
  }

  getGemMaterials() {
    return [
      { value: 'DIAMOND', viewValue: 'Diamond', color: '#F1F7FB' },
      { value: 'RUBY', viewValue: 'Ruby', color: '#9B111E' },
      { value: 'SAPPHIRE', viewValue: 'Sapphire', color: '#0F5288' },
      { value: 'EMERALD', viewValue: 'Emerald', color: '#4C9955' },
      { value: 'ALEXANDRITE', viewValue: 'Alexandrite', color: '#534a74' },
      { value: 'AMETHYST', viewValue: 'Amethyst', color: '#8B7CDB' },
      { value: 'AQUAMARINE', viewValue: 'Aquamarine', color: '#4089ae' },
      { value: 'CITRINE', viewValue: 'Citrine', color: '#F3A414' },
      { value: 'GARNET', viewValue: 'Garnet', color: '#872626' },
      { value: 'MOLDAVITE', viewValue: 'Moldavite', color: '#7f874f' },
      { value: 'PARAIBA', viewValue: 'Paraiba', color: '#7eded4' },
      { value: 'PERIDOT', viewValue: 'Peridot', color: '#A4E666' },
      { value: 'SPESSARTITE', viewValue: 'Spessartite', color: '#6BCAE2' },
      { value: 'SPHENE', viewValue: 'Sphene', color: '#c8bd64' },
      { value: 'SPINEL', viewValue: 'Spinel', color: '#a80a30' },
      { value: 'TANZANITE', viewValue: 'Tanzanita', color: '#0E2798' },
      { value: 'TOURMALINE', viewValue: 'Tourmaline', color: '#0E2798' },
      { value: 'QUARTZ', viewValue: 'Quartz', color: '#DDDDDF' },
      { value: 'TOPAZ', viewValue: 'Topaz', color: '#7ECFE2' },
      { value: 'ZIRCON', viewValue: 'Zircon', color: '#F1F7FB' }
    ];
  }


  getDiamondCut() {
    return [
      { value: 'POOR', viewValue: 'Poor' },
      { value: 'F', viewValue: 'Faint' },
      { value: 'G', viewValue: 'Good' },
      { value: 'VG', viewValue: 'Very Good' },
      { value: 'EX', viewValue: 'Excellent' },
    ]
  }

  getDiamondShape() {
    return [
      { value: 'brilliant', viewValue: 'Round', active: false, icon: 'icon-JEW_ROUND iconx32' },
      { value: 'princess', viewValue: 'Princess', active: false, icon: 'icon-JEW_PRINCESS iconx32' },
      { value: 'cushion', viewValue: 'Cushion', active: false, icon: 'icon-JEW_CUSHION iconx32' },
      { value: 'emeral', viewValue: 'Emerald', active: false, icon: 'icon-JEW_EMERALD iconx32' },
      { value: 'pear', viewValue: 'Pearl', active: false, icon: 'icon-JEW_PEARL iconx32' },
      { value: 'oval', viewValue: 'Oval', active: false, icon: 'icon-JEW_OVAL iconx32' },
      { value: 'radiant', viewValue: 'Radiant', active: false, icon: 'icon-JEW_RADIANT iconx32' },
      { value: 'asscher', viewValue: 'Asshcher', active: false, icon: 'icon-JEW_ASSCHER iconx32' },
      { value: 'marquise', viewValue: 'Marquise', active: false, icon: 'icon-JEW_MARQUISE iconx32' },
      { value: 'heart', viewValue: 'Heart', active: false, icon: 'icon-JEW_HEART iconx32' },
    ]
  }

  getDiamondClarity() {
    return [
      { value: 'I1' },
      { value: 'SI2' },
      { value: 'SI1' },
      { value: 'VS2' },
      { value: 'VS1' },
      { value: 'VVS2' },
      { value: 'VVS1' },
      { value: 'IF' },
      { value: 'FL' },
    ]
  }

  getDiamondColor() {
    return [
      { value: 'FANCY' },
      { value: 'M' },
      { value: 'L' },
      { value: 'K' },
      { value: 'J' },
      { value: 'I' },
      { value: 'G' },
      { value: 'F' },
      { value: 'E' },
      { value: 'D' }
    ]
  }

  getDiamondPolish() {
    return [
      { value: 'G', viewValue: 'Good' },
      { value: 'VG', viewValue: 'Very Good' },
      { value: 'EX', viewValue: 'Excellent' },
    ]
  }

  getDiamondSymmetry() {
    return [
      { value: 'G', viewValue: 'Good' },
      { value: 'VG', viewValue: 'Very Good' },
      { value: 'EX', viewValue: 'Excellent' },
    ]
  }

  getDiamondFluorescence() {
    return [
      { value: 'VS', viewValue: 'Very strong' },
      { value: 'S', viewValue: 'Strong' },
      { value: 'M', viewValue: 'Medium' },
      { value: 'F', viewValue: 'Faint' },
      { value: 'N', viewValue: 'None/Neg.' },
    ]
  }
}
